import React from 'react';
import './Tooltip.css';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const Tooltip = ({ content, children, red, placement, disabled }) => {
  const tooltipClass = red ? 'red-tooltip notranslate' : 'notranslate';

  return (
    <Tippy
      arrow={false}
      content={content || null}
      className={tooltipClass}
      placement={placement || 'bottom'}
      style={{ backgroundColor: 'black' }}
      disabled={disabled}
      delay={[500, 0]}
    >
      <span>{children}</span>
    </Tippy>
  );
};

export default Tooltip;
